import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { TrustpilotComponent } from '../../../app/content/layout/components/general/trustpilot/trustpilot.component';
import { withCommonDecorators } from '../../_utils/story-helpers';

const meta: Meta<TrustpilotComponent> = {
  title: 'Atoms/Trustpilot/Trustpilot Widget',
  component: TrustpilotComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
};
export default meta;
type Story = StoryObj<TrustpilotComponent>;

export const DarkTheme: Story = {
  args: {
    theme: 'dark',
    styleHeightPx: 40,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-trustpilot')).toBeTruthy();
  },
};

export const LightTheme: Story = {
  args: {
    theme: 'light',
    styleHeightPx: 40,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-trustpilot')).toBeTruthy();
  },
};

export const LargeWidget: Story = {
  args: {
    theme: 'dark',
    styleHeightPx: 100,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-trustpilot')).toBeTruthy();
  },
};
